import {ILogger} from './default-log.service';
import {Injectable} from '@angular/core';

@Injectable()
export class LogService implements ILogger {
	/**
	 * @param errorResponse
	 * @return {string} the error message which was embedded in the error,
	 * or null if none found.
	 * @private
	 */
	private static _extractMessageFromJsonBody(
		errorResponse: any,
	): string | null {
		try {
			if (!errorResponse && !errorResponse.error) {
				return null;
			}

			return errorResponse.error.message;
		} catch (e) {
			return null;
		}
	}

	/* eslint-disable:no-console */
	trace(message: string, error?: any): void {
		if (error) {
			const errorMessage = message + ' - ' + this.getErrorMessage(error);
			if (console && console.trace) {
				console.trace(errorMessage);
			}
		} else {
			if (console && console.trace) {
				console.trace(message);
			}
		}
	}

	debug(message: string, error?: any): void {
		if (error) {
			const errorMessage = message + ' - ' + this.getErrorMessage(error);
			if (console && console.log) {
				console.log(errorMessage);
			}
		} else {
			if (console && console.log) {
				console.log(message);
			}
		}
	}

	warn(message: string, error?: any): void {
		if (error) {
			const errorMessage = message + ' - ' + this.getErrorMessage(error);
			if (console && console.warn) {
				console.warn(errorMessage);
			}
		} else {
			if (console && console.warn) {
				console.warn(message);
			}
		}
	}

	error(message: string, error?: any): void {
		if (error) {
			const errorMessage = message + ' - ' + this.getErrorMessage(error);
			if (console && console.error) {
				console.error(errorMessage);
			}
		} else {
			if (console && console.error) {
				console.error(message);
			}
		}
	}

	info(message: string, error?: any): void {
		if (error) {
			const errorMessage = message + ' - ' + this.getErrorMessage(error);
			if (console && console.info) {
				console.info(errorMessage);
			}
		} else {
			if (console && console.info) {
				console.info(message);
			}
		}
	}

	/** @internal */
	private getErrorMessage(error: any): string {
		let message = `EXCEPTION: ${this._extractMessage(error)}`;

		if (!error) {
			return message;
		}

		// Add all properties from the
		// error object to the error message.
		try {
			message += '\n';

			for (const key in error) {
				if (Object.prototype.hasOwnProperty.call(error, key)) {
					message += '\n' + key + ' -> ' + JSON.stringify(error[key]);
				}
			}
		} catch (e) {
			// do nothing.
		}

		return message;
	}

	/** @internal */
	private _extractMessage(error: any): string {
		const message = LogService._extractMessageFromJsonBody(error);

		if (message) {
			return message;
		}

		return error instanceof Error ? error.message : error.toString();
	}
}
